import React, { FunctionComponent, useEffect } from 'react';
import { StyleSheet } from 'react-native';
import { Overlay } from 'react-native-elements';
import { useRootStackNavigation } from '../../navigation/hooks';
import { NotificationItem } from '../../reminders/store/types';
import { useStateStore } from '../../stores/useStateStore';
import { useNotificationSounds } from '../../utils/systemSounds';
import NotificationModalView from './components/NotificationModalView';

interface NotificationModalProps {
  items: NotificationItem[];
}

// TODO: This only shows one notification at a time right now. We need to modify the view to show multiple at once.
const NotificationModal: FunctionComponent<NotificationModalProps> = (
  props
) => {
  const { items } = props;
  const item = items?.[0];

  const sound_id = useStateStore(
    (state) => state.current_user?.systemPreferences?.androidNotificationSoundID
  );

  const dismissNotification = useStateStore(
    (state) => state.dismissNotification
  );
  const handleDismissNotification = () => {
    // TODO: This is currently dismissing all notifications. We need to add support where we show each notification independently, and then let the user dismiss each one as they want.
    items.map(dismissNotification);
  };

  const { navigate } = useRootStackNavigation();
  const handleViewDetails = () => {
    // FIXME: This will dismiss all items when trying to view something
    handleDismissNotification();
    navigate('CalendarItemDetails', { id: item.id, type: item.type });
  };

  const { playByID, stop, status } = useNotificationSounds();

  useEffect(() => {
    if (status === 'ready' && item) {
      playByID(sound_id || undefined);
    }

    return () => stop();
  }, [item, playByID, stop, sound_id, status]);

  return (
    <Overlay
      isVisible={!!item}
      onBackdropPress={handleDismissNotification}
      overlayStyle={styles.overlay}
    >
      <NotificationModalView
        item={item}
        onDismiss={handleDismissNotification}
        onViewDetails={handleViewDetails}
      />
    </Overlay>
  );
};

const styles = StyleSheet.create({
  overlay: {
    backgroundColor: 'transparent',
    shadowColor: 'transparent',
    alignItems: 'center',
    maxWidth: '100%',
    padding: 0,
  },
});

export default NotificationModal;
